import React, { useCallback } from "react";
import { HttpClient, HttpError } from "./client";
import { HttpCache } from "./httpCache";

/**
 * 
 * @param requestName Request/Command/Query name (endpoint)
 * @param autoExecute Either use execute function, or just auto execute (usefull for "GETs")
 */
export function useRequest<TResponse>(requestName: string, saveToCache: boolean = false) {
	const [data, setData] = React.useState<TResponse>();
	const [error, setError] = React.useState<HttpError>();
	const [loading, setLoading] = React.useState(false);

	const execute = useCallback(async (request?: any) => {
		const cached = HttpCache.get<TResponse>(requestName);
		if (saveToCache && cached) {
			console.log('Got response from cache', cached);
			return setData(cached);
		}

		setLoading(true);
		try {
			const res: any = await HttpClient.execute(requestName, request);
			if (Array.isArray(res?.results)) {
				setData(res.results);
				if (saveToCache) {
					HttpCache.add(requestName, res.results);
				}
				return res.results;
			} else {
				setData(res);
				if (saveToCache) {
					HttpCache.add(requestName, res);
				}
				return res;
			}
		} catch (e) {
			if (e instanceof HttpError) {
				setError(e);
			} else {
				setError(new HttpError("Unknown error", 500));
			}
		} finally {
			setLoading(false);
		}
	}, [requestName, saveToCache]);

	return {
		execute,
		data,
		loading,
		error
	}
}